import { makeStyles } from '@material-ui/core'

const drawerWidth = 389 // Largura do drawer quando aberto

export const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    position: 'absolute',
    zIndex: 1300,
    '& .MuiDrawer-paper': {
      width: 320
    },
    [theme.breakpoints.up('lg')]: {
      '& .MuiDrawer-paper': {
        width: drawerWidth
      }
    }
  },
  drawerRoot: {
    display: 'flex',
    position: 'fixed',
    '& .MuiDrawer-paper': {
      marginRight: '10px',
      position: 'fixed',
      borderRadius: '8px',
      // height: 'calc(100% - 119px)',
      transition: theme.transitions.create(['width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    '& .MuiDrawer-paperAnchorDockedRight': {
      borderLeft:
        '1px solid ' +
        (theme.palette.type === 'dark'
          ? theme.palette.dark_700.main
          : theme.palette.gray_stroke.main)
    },
    '& .MuiListItem-root:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_700.main
          : theme.palette.blue_50.main
    }
  },
  drawerPaper: {
    position: 'fixed',
    // whiteSpace: 'nowrap',
    width: drawerWidth,
    height: 'calc(100% - 49px)',
    right: 0,
    left: 'auto',

    padding: '8px',
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    borderLeft:
      '1px solid ' +
      (theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_stroke.main),
    overflowX: 'hidden',
    overflowY: 'clip',
    ...theme.scrollbarStylesSoft
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    overflowY: 'auto',
    ...theme.scrollbarStylesSoft,
    borderRadius: '16px',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: 50,
    right: 0,
    left: 'auto',
    [theme.breakpoints.up('lg')]: {
      width: 55
    }
  },
  drawerClosed: {
    width: 50, // Largura do drawer quando fechado
    flexShrink: 0,
    overflowX: 'hidden',
    '& $drawerPaper': {
      width: 50,
      overflowX: 'hidden',
      right: 0,
      left: 'auto',
      transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    [theme.breakpoints.up('lg')]: {
      width: 55,
      '& $drawerPaper': {
        width: 55
      }
    }
  },
  header: {
    padding: theme.spacing(1, 2),
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    borderBottom: `1px solid ${
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_stroke.main
    }`,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    minHeight: 48,
    '& span': {
      fontWeight: '500',
      fontSize: '1rem',
      width: '100%',
      textAlign: 'center',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.blue_300.main
    }
  },
  headerChat: {
    justifyContent: 'space-between'
  },
  tabs: {
    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.blue_300.main,
      width: '100%'
    },
    '& .MuiTab-root': {
      minWidth: '50%'
    }
  },
  tab: {
    minWidth: 50,
    width: '50%',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '&.Mui-selected': {
      color: theme.palette.blue_300.main
    }
  },
  tabLabel: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    textTransform: 'none',
    fontWeight: '600'
  },
  tabIcon: {
    marginRight: theme.spacing(1),
    fontSize: '1.25rem'
  },
  form: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '9px'
  },
  chatList: {
    padding: '0 16px 0 4px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    height: 'calc(100% - 150px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    ...theme.scrollbarStylesSoft
  },
  userItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: theme.spacing(1, 2),
    borderRadius: '8px',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_700.main
          : theme.palette.gray_50.main
    }
  },
  userNameContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  badgeCountMessage: {
    position: 'absolute',
    top: 35,
    left: 40,
    backgroundColor: theme.palette.green_200.main,
    color: theme.palette.red_100.main,
    borderRadius: '50%',
    width: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.75rem',
    fontWeight: '600',
    padding: '0 4px',
    '& .MuiChip-label': {
      padding: 0,
      color: theme.palette.white_100.main
    }
  },
  miniUnreadBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 25,
    right: 0,
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: theme.palette.green_200.main,
    color: theme.palette.white_100.main,
    fonteWeight: '600'
  },
  lastMessage: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main,
    fontSize: '0.8rem',
    opacity: 0.8,
    fontWeight: '400'
  },
  avatar: {
    // marginRight: theme.spacing(1.5),
    width: '40px',
    height: '40px',
    [theme.breakpoints.up('lg')]: {
      width: '40px',
      height: '40px'
    }
  },
  avatarHeader: {
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  circle: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main,
    fontSize: '1.25rem',
    fontWeight: '500',
    [theme.breakpoints.up('lg')]: {
      width: '40px',
      height: '40px'
    }
  },
  loadingContainer: {
    padding: theme.spacing(2),
    textAlign: 'center'
  },
  userItemText: {
    '& span': {
      fontWeight: '600',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },
  boxTitleNewChat: {
    fontWeight: '600',
    fontSize: '1rem'
  },

  // Conteúdo do drawer fechado
  closedDrawerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '8px',
    gap: '8px'
  },
  avatarContainer: {
    position: 'relative',
    cursor: 'pointer'
  },

  addGroupButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1, 2),
    marginBottom: theme.spacing(1)
  },
  addGroupButton: {
    width: '100%',
    borderRadius: theme.spacing(1)
  },
  addFab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 1
  },
  newGroupButton: {
    width: '100%',
    borderRadius: theme.spacing(1),
    boxShadow: 'none',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    color: theme.palette.green_200.main,
    '&:hover': {
      backgroundColor: theme.palette.green_200.main,
      color: theme.palette.white_100.main,
      boxShadow: 'none'
    }
  },
  closedDrawerDivider: {
    margin: theme.spacing(1, 0),
    width: '35px'
  },
  openDrawerButton: {
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_300.main
    },
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.white_100.main
    },
    '&:hover svg': {
      color: theme.palette.blue_300.main
    }
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_stroke.main
        : theme.palette.gray_300.main
  },

  searchIcon: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  searchInput: {
    width: '100%'
  },

  statusBadge: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: 12,
    height: 12,
    borderRadius: '50%',
    border:
      theme.palette.type === 'dark'
        ? `2px solid` + theme.palette.dark_400.main
        : `2px solid` + theme.palette.white_100.main,
    zIndex: 1
  },
  onlineBadge: {
    backgroundColor: theme.palette.green_200.main
  },
  offlineBadge: {
    backgroundColor: theme.palette.red_100.main
  }
}))
